/*
 * Redolia smart search — the results page (/search).
 *
 * The same engine as the search panel (assets/rdl-smart-search.js), on a full page: every ranked match,
 * re-ranked as the words change, with sorting, a few filters, shortcuts to houses and notes, and the
 * Redolia AI advisor for requests the index cannot settle.
 *
 * The theme's own results stay in the page underneath. They are hidden only once this has drawn, so a
 * visitor without JavaScript, or a day this file fails to load, still gets the stock results.
 */
(() => {
  const root = document.getElementById('rdl-results');
  if (!root) return;
  const $ = (sel) => root.querySelector(sel);
  const input = $('.rdsr-input');
  const elUnderstood = $('.rdsr-understood');
  const elEnts = $('.rdsr-ents');
  const elAi = $('.rdsr-ai');
  const elTools = $('.rdsr-tools');
  const elCount = $('.rdsr-count');
  const elMeant = $('.rdsr-meant');
  const elGrid = $('.rdsr-grid');
  const elMore = $('.rdsr-more');
  const elNone = $('.rdsr-none');
  const elSort = $('.rdsr-sort select');
  const PAGE = 24;
  const nativeCount = Number(root.getAttribute('data-native') || 0);

  let S = null, U = null;
  let ranked = [], shown = 0, lastRes = null, timer = 0;
  const filter = { who: '', price: '', stock: false };
  let aiFor = '', aiAbort = null, aiTimer = 0;
  const aiCache = new Map();

  /** The theme's own heading, field and result grid: out of the way once ours is on screen. */
  const natives = () => [...document.querySelectorAll('.shopify-section')].filter((el) => /__(search|main)$/.test(el.id));
  function showNative(resultsToo) {
    for (const el of natives()) el.hidden = /__search$/.test(el.id) ? true : !resultsToo;
  }

  function card(x, concepts, first) {
    const p = x.p;
    const name = p.t.toLowerCase().startsWith(p.b.toLowerCase() + ' ') ? p.t.slice(p.b.length + 1) : p.t;
    return (
      `<li class="rdsr-item"><a class="rdsr-card" href="/products/${U.esc(p.h)}">` +
      `<span class="rdsr-img">${p.i ? `<img src="${U.esc(p.i)}?width=480" alt="" loading="${first ? 'eager' : 'lazy'}" decoding="async" width="240" height="240" data-rdls-h="${U.esc(p.h)}">` : ''}${p.bo ? '<span class="rdsr-out rdsr-bo">Boutique only</span>' : p.av ? '' : '<span class="rdsr-out">Sold out</span>'}</span>` +
      `<span class="rdsr-brand">${U.mark(p.b, x.words)}</span>` +
      `<span class="rdsr-name">${U.mark(name, x.words)}</span>` +
      `<span class="rdsr-notes">${U.notesLine(p, x.words, concepts)}</span>` +
      `<span class="rdsr-price">${p.bo ? '' : `${U.money(p.p)}${p.cp ? ` <s>${U.money(p.cp)}</s>` : ''}`}</span>` +
      `</a></li>`
    );
  }

  function aiCard(x) {
    const p = x.p;
    const name = p.t.toLowerCase().startsWith(p.b.toLowerCase() + ' ') ? p.t.slice(p.b.length + 1) : p.t;
    return (
      `<a class="rdsr-pick" href="/products/${U.esc(p.h)}">` +
      `<span class="rdsr-pick-img">${p.i ? `<img src="${U.esc(p.i)}?width=200" alt="" decoding="async" width="92" height="92" data-rdls-h="${U.esc(p.h)}">` : ''}</span>` +
      `<span class="rdsr-pick-info"><span class="rdsr-brand">${U.esc(p.b)}</span><span class="rdsr-name">${U.esc(name)}</span>` +
      `<span class="rdsr-notes">${U.esc(x.why)}</span><span class="rdsr-price">${U.money(p.p)}</span></span></a>`
    );
  }

  function passes(p) {
    if (filter.stock && !p.av) return false;
    if (filter.who === 'Men' && p.g === 'Women') return false;
    if (filter.who === 'Women' && p.g === 'Men') return false;
    if (filter.who === 'Unisex' && p.g !== 'Unisex') return false;
    if (filter.price === 'a' && p.p >= 150) return false;
    if (filter.price === 'b' && (p.p < 150 || p.p > 300)) return false;
    if (filter.price === 'c' && p.p <= 300) return false;
    return true;
  }

  function arrange() {
    let list = lastRes ? lastRes.list(600).filter((x) => passes(x.p)) : [];
    const sort = elSort.value;
    const P = (x) => (x.p.bo ? null : x.p.p);
    if (sort === 'low') list = list.slice().sort((a, b) => (P(a) ?? 1e9) - (P(b) ?? 1e9));
    else if (sort === 'high') list = list.slice().sort((a, b) => (P(b) ?? -1) - (P(a) ?? -1));
    else if (sort === 'new') list = list.slice().sort((a, b) => (a.p.c < b.p.c ? 1 : a.p.c > b.p.c ? -1 : 0));
    ranked = list;
    shown = 0;
    elGrid.innerHTML = '';
    more();
    const q = input.value.trim();
    const total = lastRes ? lastRes.total : 0;
    elCount.textContent = !q
      ? 'New in at Redolia'
      : lastRes && lastRes.near
        ? `${U.plural(ranked.length, 'perfume')} in the same direction`
        : ranked.length === total
        ? `${U.plural(total, 'result')} for “${q}”`
        : `${ranked.length} of ${U.plural(total, 'result')} for “${q}”`;
    elNone.hidden = ranked.length > 0;
    if (!ranked.length && total) elNone.innerHTML = `<p class="rdsr-none-t">Nothing is left with these filters.</p><p><button type="button" class="rdsr-chip" data-reset>Clear the filters</button></p>`;
  }

  function more() {
    const next = ranked.slice(shown, shown + PAGE);
    elGrid.insertAdjacentHTML('beforeend', next.map((x, i) => card(x, lastRes ? lastRes.q.concepts : [], shown === 0 && i < 8)).join(''));
    const first = elGrid.children[shown];
    shown += next.length;
    elMore.hidden = shown >= ranked.length;
    if (!elMore.hidden) elMore.textContent = `Show ${Math.min(PAGE, ranked.length - shown)} more`;
    return first;
  }

  function home() {
    lastRes = null;
    elUnderstood.innerHTML = '';
    elMeant.innerHTML = '';
    elAi.hidden = true;
    const ix = S.index();
    const fresh = ix.p.filter((p) => p.av && p.i && p.p >= 60).sort((a, b) => (a.c < b.c ? 1 : -1)).slice(0, 12);
    lastRes = { total: fresh.length, q: { concepts: [] }, list: () => fresh.map((p) => ({ p, s: 1, words: null })) };
    elEnts.innerHTML = `<span class="rdsr-label">Popular</span>` + S.cfg.popular.map((t) => `<button type="button" class="rdsr-chip" data-q="${U.esc(t)}">${U.esc(t)}</button>`).join('');
    elTools.hidden = false;
    arrange();
    showNative(false);
  }

  function run(raw, push) {
    raw = String(raw || '');
    if (push) {
      const url = raw.trim() ? `${location.pathname}?q=${encodeURIComponent(raw.trim())}` : location.pathname;
      try { history.replaceState(null, '', url); } catch (e) { /* not allowed here */ }
    }
    // the tab's title follows what is on the page, not the stock count the server wrote
    document.title = raw.trim() ? `Search: ${raw.trim()} – Redolia Perfumery` : 'Search – Redolia Perfumery';
    if (!raw.trim()) return home();
    const res = (lastRes = S.searchNow(raw));
    const q = res.q;
    elUnderstood.innerHTML = q.chips.length ? `<span class="rdsr-label">Understood</span>${q.chips.map((c) => `<span class="rdsr-u">${U.esc(c)}</span>`).join('')}` : '';
    elEnts.innerHTML = res.entities.length
      ? `<span class="rdsr-label">Go straight to</span>` +
        res.entities.map((e) => (e.handle
          ? `<a class="rdsr-chip rdsr-chip--ent" href="/collections/${U.esc(e.handle)}"><span>${e.label}</span>${U.esc(e.name)}</a>`
          : `<button type="button" class="rdsr-chip rdsr-chip--ent" data-q="${U.esc(e.name)}"><span>${e.label}</span>${U.esc(e.name)}</button>`)).join('')
      : '';
    elMeant.innerHTML =
      (res.fuzzy.length && res.total ? `Showing results for <strong>${U.esc(res.fuzzy.map((f) => f[1]).join(' '))}</strong>. ` : '') +
      (res.reference ? `Closest to <a href="/products/${U.esc(res.reference.h)}"><strong>${U.esc(res.reference.t)}</strong></a> by shared notes.` : '');
    elTools.hidden = !res.total;
    arrange();
    if (!res.total) {
      elNone.hidden = false;
      elNone.innerHTML =
        `<p class="rdsr-none-t">No perfume matches “${U.esc(raw.trim())}” by name or notes.</p>` +
        `<p class="rdsr-none-s">Try a note, a house or a price: ${['vanilla', 'oud', 'under $200', 'for her'].map((t) => `<button type="button" class="rdsr-chip" data-q="${t}">${t}</button>`).join(' ')}</p>`;
    }
    // The theme's own results only when ours found nothing, the advisor has nothing either, and the theme's did.
    if (!advisor(raw, res)) showNative(!res.total && nativeCount > 0);
    else showNative(false);
  }

  /** Nothing matched the words, but the advisor picked bottles: fill the page with what sits closest to them. */
  function around(answer, res) {
    const near = answer.picks.length ? S.similar(answer.picks.map((x) => x.p), res.q, 48) : [];
    if (!near.length) { showNative(nativeCount > 0 && !answer.picks.length); return; }
    lastRes = { total: near.length, q: res.q, list: () => near, near: true };
    elTools.hidden = false;
    elMeant.innerHTML = 'No bottle carries these exact words, so these are the perfumes closest to the picks above, by shared notes.';
    arrange();
    showNative(false);
  }

  function advisor(raw, res) {
    clearTimeout(aiTimer);
    if (aiAbort) aiAbort.abort();
    const key = U.norm(raw);
    aiFor = key;
    const words = raw.trim().split(/\s+/).length;
    const ask = S.cfg.ai && raw.trim().length >= 4 && (S.wants(res, raw) || words >= 3);
    if (!ask) { elAi.hidden = true; return false; }
    const draw = (answer) => {
      if (aiFor !== key) return;
      if (!answer || (!answer.picks.length && !answer.say)) { elAi.hidden = true; if (!res.total) showNative(nativeCount > 0); return; }
      elAi.hidden = false;
      elAi.innerHTML =
        `<div class="rdsr-ai-head">${U.SPARK}<span>Redolia AI</span></div>` +
        (answer.say ? `<p class="rdsr-ai-say">${U.esc(answer.say)}</p>` : '') +
        (answer.picks.length ? `<div class="rdsr-picks">${answer.picks.map(aiCard).join('')}</div>` : '');
      if (answer.picks.length && !res.total) elNone.hidden = true;
      if (!res.total) around(answer, res);
    };
    if (aiCache.has(key)) { draw(aiCache.get(key)); return true; }
    elAi.hidden = false;
    elAi.innerHTML = `<div class="rdsr-ai-head">${U.SPARK}<span>Redolia AI is reading your request…</span></div><div class="rdsr-picks rdsr-picks--wait"><i></i><i></i><i></i><i></i></div>`;
    aiTimer = setTimeout(() => {
      aiAbort = new AbortController();
      const stop = setTimeout(() => aiAbort && aiAbort.abort(), 10000);
      fetch(S.cfg.ai, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ q: raw.slice(0, 200) }), signal: aiAbort.signal })
        .then((r) => (r.ok ? r.json() : Promise.reject(new Error('advisor ' + r.status))))
        .then((d) => {
          clearTimeout(stop);
          const ix = S.index();
          const answer = { say: d.say || '', picks: (d.picks || []).map((x) => ({ p: ix.p.find((p) => p.h === x.h), why: x.why || '' })).filter((x) => x.p) };
          aiCache.set(key, answer);
          draw(answer);
        })
        .catch(() => { clearTimeout(stop); if (aiFor === key) { elAi.hidden = true; if (!res.total) showNative(nativeCount > 0); } });
    }, 400);
    return true;
  }

  function start() {
    S = window.RDLSearch;
    if (!S) return;
    U = S.util;
    S.load()
      .then(() => {
        root.hidden = false;
        run(input.value, false);
        if (input.value.trim()) S.remember(input.value);
      })
      .catch(() => { /* the theme's own results are still on the page */ });
  }

  input.addEventListener('input', () => {
    clearTimeout(timer);
    timer = setTimeout(() => S && S.index() && run(input.value, true), 160);
  });
  root.addEventListener('submit', (e) => {
    if (!S || !S.index()) return; // let the form load the stock page
    e.preventDefault();
    run(input.value, true);
    if (input.value.trim()) S.remember(input.value);
    input.blur();
  });
  root.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    const q = t.closest('[data-q]');
    if (q) { input.value = q.getAttribute('data-q'); run(input.value, true); window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    const f = t.closest('[data-f]');
    if (f) {
      const [k, v] = f.getAttribute('data-f').split(':');
      if (k === 'stock') filter.stock = !filter.stock;
      else filter[k] = filter[k] === v ? '' : v;
      for (const b of root.querySelectorAll('[data-f]')) {
        const [bk, bv] = b.getAttribute('data-f').split(':');
        b.setAttribute('aria-pressed', String(bk === 'stock' ? filter.stock : filter[bk] === bv));
      }
      return arrange();
    }
    if (t.closest('[data-reset]')) {
      filter.who = ''; filter.price = ''; filter.stock = false;
      for (const b of root.querySelectorAll('[data-f]')) b.setAttribute('aria-pressed', 'false');
      return arrange();
    }
    if (t.closest('.rdsr-more')) { const first = more(); if (first) { const a = first.querySelector('a'); if (a) a.focus(); } }
  });
  elSort.addEventListener('change', arrange);

  if (window.RDLSearch) start();
  else document.addEventListener('rdl-search-ready', start, { once: true });
})();
